import DocumentControlContextProvider from "./DocumentControlContext";
import { FolderSearchProvider } from "./FolderSearchContext";
import { BookingQueueSearchContextProvider } from "./SearchContexts/BookingQueue";
import { BookingsProvider } from "./BookingsContext";
import { StaffingSearchProvider } from "./SearchContexts/Staffing";

const GlobalContextProvider = ({ children }) => {
  return (
    <>
      <BookingQueueSearchContextProvider>
        <DocumentControlContextProvider>
          <FolderSearchProvider>
            <BookingsProvider>
              <StaffingSearchProvider>{children}</StaffingSearchProvider>
            </BookingsProvider>
          </FolderSearchProvider>
        </DocumentControlContextProvider>
      </BookingQueueSearchContextProvider>
    </>
  );
};

export default GlobalContextProvider;
